import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

export const jobsListingApi = catchAsync(async (currentPage: number, categoryQuery: string, jobTypeQuery: string, salaryMinQuery: number, salaryMaxQuery: number, industryQuery: string, locationQuery: string, sortOrder: any) => {  
    // Build the base URL
    let url = `job/job-list/${currentPage}/12/${sortOrder}`;
    
    // Add query parameters conditionally
    const queryParams = [];
    if (categoryQuery) {
        queryParams.push(`category=${categoryQuery}`);
    }
    if (jobTypeQuery) {
        queryParams.push(`type=${jobTypeQuery}`);
    }

    if (salaryMinQuery) {
        queryParams.push(`salaryMin=${salaryMinQuery}`);
    }

    if (salaryMaxQuery) {
        queryParams.push(`salaryMax=${salaryMaxQuery}`);
    }

    if (industryQuery) {
        queryParams.push(`title=${industryQuery}`);
    }

    if (locationQuery) {
        queryParams.push(`location=${locationQuery}`);
    }

    /*if (sortOrder) {
        queryParams.push(`sort=${sortOrder}`);
    }*/

    // Append query parameters to the URL
    if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
    }

    const data = await httpsCall.get(url);
    //console.log(data);
    return data; 
});